import { Component, Injectable, Input, OnChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../../app/utils/alert.service';
import { CallHistoryReportService } from '../../../../../app/services/reports.callhistory.service';
import { BindComponentService } from '../../../../../app/utils/bind.component.service';
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';
import { CallHistoryDetailReport } from '../../../../../app/models/reports.detail.callhistory.model';
import { LoadingComponent } from '../../modalLoading/content.component';

  import * as _ from "lodash";
import * as moment from 'moment';


/**
 * @author Edivaldo Mascarenhas Jr.
 * @version $Id: content.component.ts 62116 2017-09-11 18:18:18Z edivaldo.m.junior $
 */
@Component({
  selector: 'callHistoryReport',
  templateUrl: './content.template.html'
})
@Injectable()
export class CallHistoryReportComponent implements OnChanges {

  private static readonly FETCH_SIZE: number = 50;
  
  private callHistoryDetailReportArray: CallHistoryDetailReport[] = [];
  private dataPackLine: DataPackLine;
  private totalRecordCount: number;
  private showNoDataFoundLabel: boolean;
  private msisdnPattern: any = '^\\d{11}$';
  private page: number;

  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() lineNumber: string;

  constructor(private callHistoryReportService: CallHistoryReportService, private alertService: AlertService, private bindComponent: BindComponentService, private modalService: NgbModal) {

  }

  ngOnChanges() {
    if (this.validateDate()) {
      let patt = new RegExp(this.msisdnPattern);
      if (patt.test(this.lineNumber)) {
        this.page = 1;
        this.openModalLoading();
        this.loadView();
      } else {
        this.alertService.warn('Número inválido');
      }
    }
  }

  private loadView() {
    this.totalRecordCount = 0;
    this.showNoDataFoundLabel = false;
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,true);
    this.callHistoryReportService.getLineDetails(this.lineNumber).subscribe(
      data => {
        let dataLine:any = data;
        this.dataPackLine = dataLine;
        this.getCallHistory();
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private formatDate(date: Date) {
    return (!this.validateDate())? '' : moment(date).format('DD/MM/YYYY');
  }

  private formatDateTime(date: Date) {
    return (!this.validateDate()) ? '' : moment(date).format('DD/MM/YYYY - HH:mm');
  }

  private validateDate(): boolean {
    let valid: boolean = true;
    if (!this.startDate || !this.endDate || !this.startDate == null || !this.endDate == null) {
      valid = false;
    }
    return valid;
  }

  private getLineDetails() {
    this.callHistoryReportService.getLineDetails(this.lineNumber).subscribe(
      data => {
        let dataLine:any = data;
        this.dataPackLine = dataLine;
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  private getCallHistory() {
    this.callHistoryReportService.getCallHistory (this.lineNumber, this.startDate, this.endDate, 1, CallHistoryReportComponent.FETCH_SIZE).subscribe(
      data => {
        if (data['totalRecordCount'] > 0) {
          this.totalRecordCount = data['totalRecordCount'];
          this.callHistoryDetailReportArray = data['result'];
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        } else {
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
          this.showNoDataFoundLabel = true;
          this.alertService.warn('Nenhum registro encontrado');
        }
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private searchText(text: string, value: string) {
    return text ? text.toLowerCase().search(value.toLowerCase()) != -1 : false;
  }

  private downloadFile(){
    this.callHistoryReportService.generateReport(this.lineNumber, this.startDate, this.endDate, 1, 60000);
  }
  private print() {
  }

  private maskMsisdn(msisdn: string): string {
    if(_.isNil(msisdn)) {
      return ''; 
    }
    if(msisdn.length == 12) {
      return '('.concat(msisdn.substr(0,3)).concat(') ').concat(msisdn.substring(3,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));  
    } else if(msisdn.length == 11) {
      return '('.concat(msisdn.substr(0,2)).concat(') ').concat(msisdn.substring(2,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));
    } 
    return msisdn;
  }

  private maskTime(originalValue: string): string {


    let decimalTimeString = originalValue;
    let decimalTime = parseFloat(decimalTimeString);
    decimalTime = decimalTime * 60;
    let hours = Math.floor((decimalTime / (60 * 60)));
    decimalTime = decimalTime - (hours * 60 * 60);
    let minutes = Math.floor((decimalTime / 60));
    decimalTime = decimalTime - (minutes * 60);
    let seconds = Math.round(decimalTime);
    if(hours < 10)
    {
      hours = 0 + hours;
    }
    if(minutes < 10)
    {
      minutes = 0 + minutes;
    }
    if(seconds < 10)
    {
      seconds = 0 + seconds;
    }
    minutes = Number(minutes)+Number(hours)*60;
    return String(minutes).concat("min").concat(" ").concat(String(seconds)).concat("s");

  }

  private concatWithZero(value: string): string {
    return (value.length == 1)? '0'.concat(value) : value;
  }

  private convertToDoubleDigits(value: string): string {
    let splitArray:string[] = value.toString().split('.');
     return (String(splitArray[1]).length < 2)? value.toString().concat('0') : value; 
  }
  
  private openModalLoading() {
    this.modalService.open(LoadingComponent);
  }

  private showMoreReports() {
    this.openModalLoading();
    this.page = this.page+1;
    this.callHistoryReportService.getCallHistory (this.lineNumber, this.startDate, this.endDate, this.page, CallHistoryReportComponent.FETCH_SIZE).subscribe(
      data => {
        if (data['totalRecordCount'] > this.callHistoryDetailReportArray.length) {
          this.totalRecordCount = data['totalRecordCount'];
          Array.prototype.push.apply(this.callHistoryDetailReportArray, data['result']);
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        } else {
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
          this.alertService.warn('Não existem mais registros para essa linha.');
        }
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.alertService.error(err.result, err);
      }
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/reports/callHistory/content.component.ts